import React, { useEffect, useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import { CheckCircle, XCircle } from 'lucide-react';

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState({ loading: true, success: false, message: '' });

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus({ loading: false, success: false, message: 'Token de vérification manquant.' });
        return;
      }
      try {
        const { data } = await api.get(`/auth/verify-email`, { params: { token } });
        setStatus({ loading: false, success: true, message: data?.message || 'Email vérifié avec succès.' });
        // Optionnel: redirection après quelques secondes
        setTimeout(() => navigate('/login', { replace: true }), 3000);
      } catch (error) {
        const msg = error.response?.data?.error || 'Échec de la vérification.';
        setStatus({ loading: false, success: false, message: msg });
      }
    };
    verify();
  }, [token, navigate]);

  if (status.loading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white shadow rounded-lg p-6 text-center">
        {status.success ? (
          <>
            <CheckCircle className="w-12 h-12 text-green-600 mx-auto" />
            <h1 className="mt-4 text-2xl font-semibold text-gray-800">Email vérifié</h1>
            <p className="mt-2 text-gray-600">{status.message}</p>
            <Link to="/login" className="mt-6 inline-block btn btn-primary">Se connecter</Link>
          </>
        ) : (
          <>
            {status.message.includes('déjà vérifié') ? (
              <>
                <CheckCircle className="w-12 h-12 text-blue-600 mx-auto" />
                <h1 className="mt-4 text-2xl font-semibold text-gray-800">Compte déjà vérifié</h1>
                <p className="mt-2 text-gray-600">{status.message}</p>
                <Link to="/login" className="mt-6 inline-block btn btn-primary">Se connecter</Link>
              </>
            ) : (
              <>
                <XCircle className="w-12 h-12 text-red-600 mx-auto" />
                <h1 className="mt-4 text-2xl font-semibold text-gray-800">Vérification échouée</h1>
                <p className="mt-2 text-gray-600">{status.message}</p>
                <div className="mt-6 flex gap-3 justify-center">
                  <Link to="/login" className="btn">Retour connexion</Link>
                  <Link to="/register" className="btn btn-primary">Créer un compte</Link>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmailPage;
